import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";
import { Field } from "react-final-form";
import Autocomplete from "../../../../components/Autocomplete";
import { useQuery } from "react-query";
import useMajorQueries from "../../hooks/useMajorQueries";
import { useSchoolId } from "../../../school/hooks/useSchoolId";
import { QUERY_KEYS } from "../../../../constants";

const MajorField: FC<ComponentProps<any>> = React.memo((props) => {
  const { fetchContainingPrograms } = useMajorQueries();
  const schoolId = useSchoolId();
  const { majorsContainingPrograms } = QUERY_KEYS;

  const { isLoading, isFetching, data } = useQuery<any>(
    [majorsContainingPrograms, schoolId],
    () => fetchContainingPrograms(schoolId),
  );

  return (
    <Field
      options={data && data.data}
      disabled={isLoading || isFetching}
      component={Autocomplete}
      {...props}
    />
  );
});

export default MajorField;
